export const enEnvironmentLocale = {
  production_selected: 'Production environment selected',
  integration_selected: 'Integration environment selected: {{environmentName}}',

  integration_non_exist_switch_production:
    'Integration ({{environmentName}}) environment does not exist, switching to production environment',
  integration_data_not_found_switch_production:
    'Integration environment ({{environmentName}}) data not found, switching to production environment',
  integration_error_switch_production:
    'Error occurred while switching to integration environment ({{environmentName}}), trying to switch to production environment',
};
